// MappingStep.tsx

import React, { useContext, useEffect, useState } from 'react'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import UserContext from '../../../../contexts/UserContext'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  RowText,
  RowsDiv,
  RowDiv,
  RowFieldDiv,
  PreviewText,
  TableBody,
  HeaderRow,
  HeaderCell,
  ItemRow,
  ItemCell,
  ButtonsDiv,
  CancelButton,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  DisabledNextButtonDiv,
  DisabledNextButtonImage,
  DisabledNextButtonText,
  MappingArea,
  Phrase,
  Preview,
} from './style'
import SpreadsheetColumnsSelects from './utils/renderSpreadsheetColumnsSelects'
import DataBaseColumnsSelects from './utils/renderDataBaseColumnsSelects'
import StockContext from '../../../../contexts/StockContext'
import axios from '../../../../config/axios'
import ModalContext from '../../../../contexts/ModalContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowRight from '../../../../assets/addStockModal/excel/arrow-right.svg'
import arrowLeft from '../../../../assets/addStockModal/excel/arrow-left.svg'
import disabledArrowRight from '../../../../assets/addStockModal/excel/disabled-arrow-right.svg'
import { defaultTranslationMapping } from './utils/defaultTranslationMapping'

interface MappingStepProps {
  isOpen: boolean
  onClose: () => void
}

const MappingStep = () => {
  const { user } = useContext(UserContext)
  const {
    setActiveTab,
    previewSpreadsheet,
    setPreviewSpreadsheet,
    translationMapping,
    setTranslationMapping,
    updateInOmie,
    setUpdateInOmie,
    calculateLength,
    setCalculateLength,
    calculateWeight,
    setCalculateWeight,
    defaultMapping,
    setDefaultMapping,
    setReview,
    setLoadingPercentage,
  } = useContext(ImportFromExcelContext)
  const { tableFile, setImportFromExcelModal, setTableFile } =
    useContext(StockContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)

  useEffect(() => {
    if (defaultMapping) {
      setTranslationMapping(defaultTranslationMapping)
    } else {
      setTranslationMapping({})
    }
  }, [defaultMapping])

  const handleSubmit = () => {
    const formData = new FormData()
    formData.append('file', tableFile[0])

    const headers = {
      'Translation-Mapping': JSON.stringify(translationMapping),
      'Update-in-omie': updateInOmie,
      'Weight-calculate': calculateWeight,
      'Length-calculate': calculateLength,
      'Content-Type': 'multipart/form-data',
    }

    axios
      .post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/excel-review`, formData, {
        headers,
      })
      .then((res) => {
        console.log(res.data)
        setModalSection('thirdExcelAdd')

        setReview(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie':
        setUpdateInOmie(!updateInOmie)
        break
      case 'defaultMapping':
        setDefaultMapping(!defaultMapping)
        break
      case 'calcLength':
        if (calculateWeight) {
          setCalculateWeight(false)
        }
        setCalculateLength(!calculateLength)
        break
      case 'calcWeight':
        if (calculateLength) {
          setCalculateLength(false)
        }
        setCalculateWeight(!calculateWeight)
        break
      default:
        console.log('Caminho inesperado ao ativar um switch toggle')
        break
    }
  }

  const handleCancelImport = () => {
    setModalSection('addStockMenu')
    setTableFile(undefined)
    setTranslationMapping({})
    setUpdateInOmie(false)
    setDefaultMapping(false)
    setCalculateLength(false)
    setCalculateWeight(false)
    setReview({ missingColumns: [], wrongColumns: [] })
    setImportFromExcelModal(false)
    setLoadingPercentage(0)
  }

  const switches: string[] = [
    'defaultMapping',
    'omie',
    'calcLength',
    'calcWeight',
  ]
  const switchesText: string[] = [
    'Mapeamento padrão',
    'Atualizar produtos na Omie',
    'Calcular comprimentos',
    'Calcular pesos',
  ]
  const switchValues: boolean[] = [
    defaultMapping,
    updateInOmie,
    calculateLength,
    calculateWeight,
  ]

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Importar tabela de estoque: mapeamento</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
        <ProgressBarLine />
        <ProgressBarCircle />
      </ProgressBarDiv>
      <Phrase>
        Especifique a que campo do nosso estoque cada coluna da planilha se
        relaciona.
      </Phrase>
      <SwitchesDiv>
        {switches.map((field, index) => (
          <SwitchDiv key={field}>
            <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
            <SwitchBox>
              <SwitchInput
                type='checkbox'
                name={field}
                checked={switchValues[index]}
                onChange={handleSwitchToggle}
              />
              <SwitchSlider className='slider'></SwitchSlider>
            </SwitchBox>
          </SwitchDiv>
        ))}
      </SwitchesDiv>
      <MappingArea>
        <RowsDiv>
          <RowDiv>
            <RowText>Campo da planilha</RowText>
            <RowFieldDiv>
              {previewSpreadsheet && (
                <SpreadsheetColumnsSelects
                  headerRow={previewSpreadsheet[0]}
                  numberOfSelects={Object.keys(previewSpreadsheet[0]).length}
                />
              )}
            </RowFieldDiv>
          </RowDiv>
          <RowDiv>
            <RowText>Campo do estoque</RowText>
            <RowFieldDiv>
              {previewSpreadsheet && (
                <DataBaseColumnsSelects
                  numberOfSelects={Object.keys(previewSpreadsheet[0]).length}
                />
              )}
            </RowFieldDiv>
          </RowDiv>
        </RowsDiv>
        <PreviewText>Preview</PreviewText>
        <Preview>
          {/* Valores dos objetos */}
          <TableBody>
            {previewSpreadsheet &&
              previewSpreadsheet.slice(0, 1).map((item, rowIndex) => (
                <HeaderRow key={rowIndex}>
                  {Object.keys(item).map((key, colIndex) => (
                    <HeaderCell key={colIndex}>{item[key]}</HeaderCell>
                  ))}
                </HeaderRow>
              ))}
            {previewSpreadsheet &&
              previewSpreadsheet
                .slice(1, previewSpreadsheet.length)
                .map((item, rowIndex) => (
                  <ItemRow key={rowIndex}>
                    {Object.keys(item).map((key, colIndex) => (
                      <ItemCell key={colIndex}>{item[key]}</ItemCell>
                    ))}
                  </ItemRow>
                ))}
          </TableBody>
        </Preview>
      </MappingArea>
      <ButtonsDiv>
        <CancelButton onClick={() => handleCancelImport()}>
          Cancelar
        </CancelButton>
        <PreviousButtonDiv onClick={() => setModalSection('firstExcelAdd')}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        {Object.keys(translationMapping).length === 0 ? (
          <DisabledNextButtonDiv>
            <DisabledNextButtonImage
              src={disabledArrowRight}
              alt='Right arrow icon'
            />
            <DisabledNextButtonText>Próximo</DisabledNextButtonText>
          </DisabledNextButtonDiv>
        ) : (
          <NextButtonDiv onClick={() => handleSubmit()}>
            <NextButtonImage src={arrowRight} alt='Right arrow icon' />
            <NextButtonText>Próximo</NextButtonText>
          </NextButtonDiv>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default MappingStep

